import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { preferencesOperations, preferencesSelectors } from "../../modules/preferences";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import { trackEvent } from "../../utils/trackAnalytics";
import PreferencesAppearanceTab from "../preferencesModal/PreferencesAppearanceTab";

const SettingsIosAppearanceGroup = props => {
  return <PreferencesAppearanceTab {...props} />;
};

SettingsIosAppearanceGroup.propTypes = {
  dateOrder: PropTypes.string.isRequired,
  thousandsSeparator: PropTypes.string.isRequired,
  skin: PropTypes.string.isRequired,
  onDateOrderChange: PropTypes.func.isRequired,
  onThousandsSeparatorChange: PropTypes.func.isRequired,
  onSkinChange: PropTypes.func.isRequired,
  onAutoBackupChange: PropTypes.func.isRequired,
  onAutoBackupLocationChange: PropTypes.func.isRequired,
  onAutoCheckUpdatesChange: PropTypes.func.isRequired,
  onAutoDownloadUpdatesChange: PropTypes.func.isRequired,
  onAutoCloseScrivenerChange: PropTypes.func.isRequired,
  globalFontSize: PropTypes.number.isRequired
};

const mapStateToProps = state => {
  return {
    dateOrder: preferencesSelectors.getDateOrder(state.present),
    thousandsSeparator: preferencesSelectors.getThousandsSeparator(state.present),
    skin: preferencesSelectors.getSkin(state.present),
    autoBackupEnabled: preferencesSelectors.getAutoBackupEnabled(state.present),
    autoBackupLocation: preferencesSelectors.getAutoBackupLocation(state.present),
    autoCheckUpdates: preferencesSelectors.getAutoCheckUpdates(state.present),
    autoDownloadUpdates: preferencesSelectors.getAutoDownloadUpdates(state.present),
    autoCloseScrivener: preferencesSelectors.getAutoCloseScrivener(state.present),
    globalFontSize: preferencesSelectors.getGlobalFontSize(state.present)
  };
};

const readonlyActions = {
  onDateOrderChange: preferencesOperations.setDateOrder,
  onThousandsSeparatorChange: preferencesOperations.setThousandsSeparator,
  onSkinChange: (skin, oldSkin) => {
    trackEvent("setPreferences", "setSkin", skin);
    trackEvent("setPreferences", "oldSkin", oldSkin);
    return preferencesOperations.setSkin(skin);
  },
  onAutoBackupChange: preferencesOperations.setAutoBackup,
  onAutoBackupLocationChange: preferencesOperations.setAutoBackupLocation,
  onAutoCheckUpdatesChange: preferencesOperations.setAutoCheckUpdates,
  onAutoDownloadUpdatesChange: preferencesOperations.setAutoDownloadUpdates,
  onAutoCloseScrivenerChange: preferencesOperations.setAutoCloseScrivener
};

const editingActions = {};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SettingsIosAppearanceGroup);
